import { SELECT_SIZE } from '../_consts';
import Selections from '../_steps/enums/SizeStep';
import WizStepId from '../_steps/enums/WizStepId';
import type { UseButtonDisabledProps } from './useButtonDisabled';

export const useChargerButtonDisabled = ({
  currentStep,
  isLoadingPdpData,
  size,
  sizingSelector,
}: Partial<UseButtonDisabledProps>) => {
  return (
    !isLoadingPdpData &&
    currentStep === WizStepId.Size &&
    sizingSelector === Selections.ChooseSize &&
    size?.value === SELECT_SIZE
  );
};
